import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { ISectiune, ISectiuneForm, ISectiuneUpdatePayload } from '../sectiuni-proiecte.interface';
import { SectiuniProiecteService } from '../sectiuni-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-edit-sectiuni-proiecte',
    templateUrl: './edit-sectiuni-proiecte.component.html',
    styleUrls: ['./edit-sectiuni-proiecte.component.scss']
})
export class EditSectiuniProiecteComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: ISectiune,
        private dialogRef: MatDialogRef<EditSectiuniProiecteComponent>,
        private sectiuniProiecteService: SectiuniProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as ISectiuneForm;
        const payload: ISectiuneUpdatePayload = {
            id_section: this.data.id,
            name,
        };

        this.sectiuniProiecteService
            .updateSectiune(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
